export default __webpack_public_path__ + "static/media/logoRoseon.d2f20490.png";